import {load} from '@shopify/theme-sections'
import '../../../styles/templates/account.scss'
import '../../../styles/templates/customers/register.scss'
import '../../sections/template-register'

load([`template-register`])
